export default class TimeSignature {
    numerator: number 
    denominator: number
  
    constructor(numerator: number, denominator: number) {
      this.numerator = numerator
      this.denominator = denominator
    }
  }